import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';

import { ComPortViewModel } from './comport-view-model';

export const fetchComPort = () => {
  return apiClientWithoutHandler.genericController.get(APIPath.comport).then((res) => {
    return res;
  });
};

export const updateComPort = (model: ComPortViewModel) => {
  return apiClientWithoutHandler.genericController.put(APIPath.comport, model).then((res) => {
    return res;
  });
};
